import cx from "classnames";
import React from "react";
import styles from "./Icon.scss";

const context = require.context("assets/icons/", false, /\.svg$/);
const icons = {};
context.keys().forEach((k) => {
  icons[k.slice(2, -4)] = context(k);
});

export const Icon = React.forwardRef(({ i, className, size, style, ...props }, ref) => (
  <span
    {...props}
    ref={ref}
    className={cx(styles.Icon, size && styles.hasSize, className)}
    style={{ ...style, fontSize: size }}
    dangerouslySetInnerHTML={{ __html: icons[i] }}
  />
));
